import { reportDefinitionService } from '_services';
import ACTIONS_REPORT_DEFINITION from '_constants/reportDefinition.constants';
import alertActions from './alert.actions';

export const receiveReportDefinitions = (reportDefinitions) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < reportDefinitions.length; i++) {
    byIdObjectToDispatch[reportDefinitions[i].reportDefinitionID] = reportDefinitions[i];
  }

  return {
    type: ACTIONS_REPORT_DEFINITION.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteReportDefinition = (reportDefinitionID) => ({
  type: ACTIONS_REPORT_DEFINITION.DELETE,
  byId: { [reportDefinitionID]: null }
});

const searchReportDefinitions = () => async (dispatch) => {
  try {
    const resp = await reportDefinitionService.search();
    if (resp?.reportDefinitions) {
      dispatch(receiveReportDefinitions(resp?.reportDefinitions));
      return resp?.reportDefinitions;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error searching report definitions.'));
  }
  return null;
};

const getReportDefinition = (reportDefinitionID) => async (dispatch) => {
  try {
    const resp = await reportDefinitionService.getById(reportDefinitionID);
    if (resp?.reportDefinition) {
      dispatch(receiveReportDefinitions([ resp.reportDefinition ]));
      return resp.reportDefinition;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving report definition: ${reportDefinitionID}.`));
  }
  return null;
};

const addReportDefinition = (reportDefinition) => async (dispatch) => {
  try {
    const resp = await reportDefinitionService.create(reportDefinition);
    if (resp?.reportDefinition) {
      dispatch(receiveReportDefinitions([ resp.reportDefinition ]));
      return resp.reportDefinition;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error creating report definition.'));
  }
  return null;
};

const updReportDefinition = (reportDefinition) => async (dispatch) => {
  try {
    const resp = await reportDefinitionService.update(reportDefinition);
    if (resp?.reportDefinition) {
      dispatch(receiveReportDefinitions([ resp.reportDefinition ]));
      return resp.reportDefinition;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error updating report definition.'));
  }
  return null;
};

const delReportDefinition = (reportDefinitionID) => async (dispatch) => {
  try {
    const resp = await reportDefinitionService.delete(reportDefinitionID);
    if (resp?.reportDefinition) {
      dispatch(deleteReportDefinition(reportDefinitionID));
      return resp.reportDefinition;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing report definition: ${reportDefinitionID}.`));
  }
  return null;
};

const reportDefinitionActions = {
  searchReportDefinitions,
  getReportDefinition,
  addReportDefinition,
  updReportDefinition,
  delReportDefinition
};

export default reportDefinitionActions;
